import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import QRCode from "react-qr-code";
import Container from "@mui/material/Container";
import dayjs from "dayjs";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import { isMobile } from "react-device-detect";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";

import HeaderText from "../../components/HeaderText";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import { getHMTime } from "../../services/StringService";

import {
  getSchoolEvent,
  EVENT_QR_KEY,
  encryptEventAttend,
} from "../../services/EventService";
import { getQrBaseUrl } from "../../services/QrService";
import {
  StripedTableCell,
  StripedTableHeadCell,
  StripedTableRow,
} from "../../components/StripedTable";

const EventSignupQr = () => {
  const { eid } = useParams();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_currentDate, setCurrentDate] = useState(dayjs());
  const [_location, setLocation] = useState({});
  const [_passType, setPassType] = useState({});
  const [_encrypted, setEncrypted] = useState({});
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_qrUrl, setQrUrl] = useState("");

  const [_event, setEvent] = useState({
    eid: "",
  });

  useEffect(() => {
    initContent();
  }, []);

  const initContent = () => {
    setShowProgress(true);

    const promises = [
      getSchoolEvent(_school, _jwt, eid),
      getQrBaseUrl(_school, _jwt),
    ];
    Promise.all(promises).then((results) => {
      let result = results[0];

      setEvent(result.data.event);
      const encrypted = encryptEventAttend(EVENT_QR_KEY, eid);
      setSearchPerformed(true);

      const baseUrl = results[1];

      if (result.data.event.isGuardianEvent === "Y") {
        setQrUrl(baseUrl + `/guardian/event/signup/qr/${eid}`);
      } else {
        setQrUrl(baseUrl + `/student/event/signup/qr/${encrypted}`);
      }
      setShowProgress(false);
    });
  };

  const getQrCode = () => {
    if (isMobile) {
      return (
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "80%", width: "80%" }}
          value={_qrUrl}
          viewBox={`0 0 256 256`}
        />
      );
    } else {
      return <QRCode size={612} value={_qrUrl} />;
    }
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Event Signup QR Code" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ display: _searchPerformed ? "" : "none" }}>
          <HeaderText text={"for: " + _event.title} />
          <TableContainer component={Paper} sx={{ mt: 0, mb: 1 }}>
            <Table size="small">
              <TableBody>
                <StripedTableRow>
                  <StripedTableHeadCell>Date</StripedTableHeadCell>
                  <StripedTableCell>
                    {dayjs(_event.startDate).format("MM/DD/YY")}
                  </StripedTableCell>
                </StripedTableRow>
                <StripedTableRow>
                  <StripedTableHeadCell>Start Time</StripedTableHeadCell>
                  <StripedTableCell>
                    {getHMTime(_event.startHour, _event.startMinute)}
                  </StripedTableCell>
                </StripedTableRow>
                <StripedTableRow>
                  <StripedTableHeadCell>End Time</StripedTableHeadCell>
                  <StripedTableCell>
                    {getHMTime(_event.endHour, _event.endMinute)}
                  </StripedTableCell>
                </StripedTableRow>
                {_event.locationName != null && (
                  <StripedTableRow>
                    <StripedTableHeadCell>Location Name</StripedTableHeadCell>
                    <StripedTableCell>{_event.locationName}</StripedTableCell>
                  </StripedTableRow>
                )}
                <StripedTableRow>
                  <StripedTableHeadCell>Main Proctor</StripedTableHeadCell>
                  <StripedTableCell>
                    {_event.first_name} {_event.last_name}
                  </StripedTableCell>
                </StripedTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <p style={{ textAlign: "center" }}>{getQrCode()}</p>
          <p>
            <a href={_qrUrl}>Link</a>
          </p>
        </Box>
      </Container>
    </>
  );
};

export default EventSignupQr;
